import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { securityCageModalValues } from '../../../app/common/options/collectionOpt';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    optionNo: number;
    handleClose: () => void;
}
export default function SecurityCageCard({ optionNo, handleClose }: Props) {
    const cageData = securityCageModalValues.find(x => x.optionNo === optionNo);

    // const isMobile = !useMediaQuery('(min-width:900px)');

    return (
        <Box sx={{ flexGrow: 1, mt: 13 }}>
            <Grid container spacing={2} direction="column" justifyContent="center" alignItems="center">
                <Grid item xs={12} sx={{ position: 'relative', pb: 0.5, pr: 0.5, mt: 2, bgcolor: '#000', borderRadius: '100% 0% 29% 71% / 0% 100% 0% 100% ' }} >
                    <Typography component='span' variant='body2' sx={{ position: 'absolute', right: 6, top: 0.1, color: '#fff' }}>
                        Tier1Asset
                    </Typography>
                    <Card sx={{ width: { xs: 360, sm: 500 }, bgcolor: '#B6DAFF'}}>
                        {cageData && <>
                            <CardHeader
                                sx={{
                                    '& .MuiTypography-root': {
                                        fontSize: '1.2rem'
                                    },
                                    '& .MuiTypography-body1': {
                                        fontSize: '1rem'
                                    }
                                }}
                                action={
                                    <Tooltip title="Close">
                                        <IconButton aria-label="close" onClick={handleClose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                }
                                title={cageData.title}
                                subheader={cageData.subTitle[0]}
                            />
                            <CardMedia
                                component="img"
                                sx={{ maxHeight: 400 }}
                                image={cageData.imageUrl}
                                alt={cageData.title}
                            />
                            <CardContent>
                                {cageData.splLines.map((spl) => (
                                    <Typography component='span' key={spl} variant='body1' sx={{ display: 'block', fontSize: 14 }}>
                                        {spl}
                                    </Typography>

                                ))}
                                {cageData.otherLines.map((oth) => (
                                    <Typography component='span' key={oth} variant='body1' sx={{ display: 'block', fontSize: 14 }}>
                                        {oth}
                                    </Typography>
                                ))}
                            </CardContent>
                        </>
                        }
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}
